import {collection, getDocsFromServer} from "firebase/firestore";
import {appFirestore} from "../../../index";

export function normalizeEmployeeEmail(email: string): string {
    return email.trim().toLowerCase();
}

// Проверяваме и изтритите/напусналите служители: входът също ги намира по имейл.
// Четем от сървъра, за да не разрешим запис по непълен списък или офлайн кеш.
export async function assertEmployeeEmailAvailable(email: string, employeeId?: string): Promise<void> {
    const normalized = normalizeEmployeeEmail(email);
    if (!normalized) throw new Error("Въведете имейл адрес на служителя.");
    const [employees, users] = await Promise.all([
        getDocsFromServer(collection(appFirestore, "employees")),
        getDocsFromServer(collection(appFirestore, "users")),
    ]).catch(() => {
        throw new Error("Имейлът не може да бъде проверен. Проверете връзката и опитайте отново. Данните не са записани.");
    });
    const duplicateEmployee = employees.docs.find(value => {
        const savedEmail = value.get("email");
        return value.id !== employeeId && typeof savedEmail === "string" &&
            normalizeEmployeeEmail(savedEmail) === normalized;
    });
    const duplicateUser = users.docs.find(value => {
        const savedEmail = value.get("email");
        return (!employeeId || value.get("employeeId") !== employeeId) && typeof savedEmail === "string" &&
            normalizeEmployeeEmail(savedEmail) === normalized;
    });
    const duplicate = duplicateEmployee || duplicateUser;
    if (duplicate) {
        const name = duplicate.get("name");
        throw new Error(typeof name === "string" && name.trim() ?
            `Имейлът вече се използва от „${name.trim()}“. Въведете друг имейл.` :
            "Имейлът вече се използва от друг служител или акаунт. Въведете друг имейл.");
    }
}
